$(document).ready(function () {
  document.querySelectorAll('[data-popup-conta]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      // fecha todos os outros antes de abrir o atual
      document.querySelectorAll('.popup-account.open').forEach(el => {
        if (el !== btn.nextElementSibling) el.classList.remove('open');
      });

      // procura o popup mais próximo (irmão direto ou dentro do mesmo bloco)
      const popup = btn.nextElementSibling?.classList.contains('popup-account')
        ? btn.nextElementSibling
        : btn.parentElement.querySelector('.popup-account');

      if (popup) {
        popup.classList.toggle('open');
      }
    });
  });

  // Fecha ao clicar fora
  document.addEventListener('click', (e) => {
    const isButton = e.target.closest('[data-popup-conta]');
    const isPopup = e.target.closest('.popup-account');
    if (!isButton && !isPopup) {
      document.querySelectorAll('.popup-account.open').forEach(el => el.classList.remove('open'));
    }
  });



  if ($(".slider-slick").length) {
    $(".slider-slick").slick({
      nextArrow: window.arrows.icon_next,
      prevArrow: window.arrows.icon_prev,
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 11,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1800,
          settings: {
            slidesToShow: 9,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 1700,
          settings: {
            slidesToShow: 7,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  }

  function discountSlider(slidesToShow, slidesToScroll, rows) {
    $("discount-slider").slick({
      arrows: false,
      slidesPerRow: slidesToShow,
      slidesToScroll: slidesToScroll,
      rows: rows,
      dots: true,
      infinite: false,
    });
  }

  function getItemsToShow(resolution) {
    var slidesToShow, slidesToScroll, rows;

    if (resolution >= 1200) {
      console.log("Desktop");
      if ($("discount-slider.slick-initialized").length) {
        $("discount-slider.slick-initialized").slick("unslick");
      }
      return;
    }

    if (resolution < 1200) {
      console.log("mobile");

      if ($("discount-slider.slick-initialized").length) {
        $("discount-slider.slick-initialized").slick("unslick");
      }
      slidesToShow = 2;
      rows = 2;
      slidesToScroll = 1;
      discountSlider(slidesToShow, slidesToScroll, rows);
      return;
    }
  }

  $(window).on("resize", function () {
    console.log("Resize");
    var win = $(window).width();
    getItemsToShow(win);
  });

  var sizeWindow = $(window).width();
  getItemsToShow(sizeWindow);

  function copyToClipboard(element) {
    var $temp = $("<input>");
    var oldValue = $(element).html();

    $("body").append($temp);
    $temp.val($(element).html()).select();
    document.execCommand("copy");
    $(element).html("COPIADO");
    setTimeout(function () {
      $(element).html(oldValue);
    }, 300);
    $temp.remove();
  }

  $("cupom").click(function () {
    copyToClipboard(this);
  });

  $.getJSON("/cart.js", (cart) => {
    console.log(cart);
    $(cart.items).each(function (index) {
      var item = this;
      setTimeout(function () {
        $('[data-product-id="' + item.product_id + '"]').addClass(
          "on_cart_added"
        );
        $('[data-product-id="' + item.product_id + '"]').attr(
          "countCart",
          item.quantity
        );
      }, 300);
    });
  });

  function error_ship_ajax(msg) {
    var $input_cep = $(".zipcode-input"),
      $input_container = $(".cart-drawer__footer__row"),
      $erro_ship = $(".erro-shipping");

    $input_cep.val("");
    $input_container.addClass("error-input");

    if (msg.length > 0) {
      $erro_ship.html(msg);
    }
    setTimeout(function () {
      $input_container.removeClass("error-input");
      $erro_ship.html("");
    }, 4000);
  }

  function shipping_ajax() {
    var $input_cep = $(".zipcode-input"),
      $shipping_list = $(".shipping_options__list"),
      $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
      $display_shipping = $(".shipping-display__wrapper"),
      $ship_name_display = $(".shipping-rate-name"),
      $container_ship_name = $(".shipping-rate-name");

    var $cep = $input_cep.val().replace(/\D/g, "");
    var $validacep = /^[0-9]{8}$/;

    console.log($validacep.test($cep));
    if ($cep == "") {
      error_ship_ajax("Campo cep está vazio");
      return;
    }

    if (!$validacep.test($cep)) {
      error_ship_ajax("Cep inválido");
      return;
    }

    $.getJSON(
      "https://viacep.com.br/ws/" + $cep + "/json/?callback=?",
      function (dados) {
        if ("erro" in dados) {
          console.log("Erro na consulta, confira o cep e tente novamente");
          return;
        }

        switch (dados.uf) {
          case "AC":
            dados.uf = "Acre";
            break;
          case "AL":
            dados.uf = "Alagoas";
            break;
          case "AP":
            dados.uf = "Amapa";
            break;
          case "AM":
            dados.uf = "Amazonas";
            break;
          case "BA":
            dados.uf = "Bahia";
            break;
          case "CE":
            dados.uf = "Ceara";
            break;
          case "DF":
            dados.uf = "Distrito Federal";
            break;
          case "ES":
            dados.uf = "Espirito Santo";
            break;
          case "GO":
            dados.uf = "Goias";
            break;
          case "MA":
            dados.uf = "Maranhao";
            break;
          case "MT":
            dados.uf = "Mato Grosso";
            break;
          case "MS":
            dados.uf = "Mato Grosso do Sul";
            break;
          case "MG":
            dados.uf = "Minas Gerais";
            break;
          case "PA":
            dados.uf = "Para";
            break;
          case "PB":
            dados.uf = "Paraiba";
            break;
          case "PR":
            dados.uf = "Parana";
            break;
          case "PE":
            dados.uf = "Pernambuco";
            break;
          case "PI":
            dados.uf = "Piaui";
            break;
          case "RJ":
            dados.uf = "Rio de Janeiro";
            break;
          case "RN":
            dados.uf = "Rio Grande do Norte";
            break;
          case "RS":
            dados.uf = "Rio Grande do Sul";
            break;
          case "RO":
            dados.uf = "Rondonia";
            break;
          case "RR":
            dados.uf = "Roraima";
            break;
          case "SC":
            dados.uf = "Santa Catarina";
            break;
          case "SP":
            dados.uf = "Sao Paulo";
            break;
          case "SE":
            dados.uf = "Sergipe";
            break;
          case "TO":
            dados.uf = "Tocantins";
            break;
        }

        $.ajax({
          type: "GET", //rest Type
          dataType: "json", //mispelled
          url:
            "/cart/shipping_rates.json?shipping_address%5Bzip%5D=" +
            $cep +
            "&shipping_address%5Bcountry%5D=" +
            "Brazil" +
            "&shipping_address%5Bprovince%5D=" +
            dados.uf,
          beforeSend: function () {
            //$('.overlay-carregando').show();
          },
          success: function (msg) {
            $shipping_list.html("");
            // $ship_name_display.html(msg.shipping_rates[0].name);
            // if($('.shipping-display.value') === 0.00){
            //   $('.shipping-display.value').html("Grátis");
            // }else{
            //   $('.shipping-display.value').html(Shopify.formatMoney(msg.shipping_rates[0].price, window.money_format));
            // }
            for (let i = 0; i < msg.shipping_rates.length; i++) {
              let $formatedPrice;
              let $estimateShip;
              if (msg.shipping_rates[i].price === 0.0) {
                $formatedPrice = "Grátis";
              } else {
                $formatedPrice = Shopify.formatMoney(
                  msg.shipping_rates[i].price,
                  window.money_format
                );
              }
              var $priceShip = msg.shipping_rates[i].price;
              if (
                msg.shipping_rates[i].delivery_days[1] == null ||
                msg.shipping_rates[i].delivery_days[1] === 0
              ) {
                $estimateShip = "";
              } else {
                $estimateShip =
                  "(" + msg.shipping_rates[i].delivery_days[1] + " dias úteis)";
              }

              var $template =
                '<li data-shipping-change class="filters-group__list__item"> <label for="shipping-option_' +
                msg.shipping_rates[i].name
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-$/, "")
                  .replace(/^-/, "") +
                '" class="filters-checkbox"> <input type="radio" name="shipping_id" value="shippingId" id="shipping-option_' +
                msg.shipping_rates[i].name
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-$/, "")
                  .replace(/^-/, "") +
                '" data-name="' +
                msg.shipping_rates[i].name +
                '" data-price="' +
                msg.shipping_rates[i].price +
                '" data-formatted-price="' +
                $formatedPrice +
                '" data-delivery="' +
                $estimateShip +
                '"> <span class="text">' +
                msg.shipping_rates[i].name +
                " - " +
                $formatedPrice +
                " " +
                $estimateShip +
                "</span> </label> </li>";

              $shipping_list.append($template);

              //$("#fretes-disponiveis > option[value='"+[i]+"']").attr("data-valor", msg.shipping_rates[i].price);
            }
            // $display_shipping.removeClass('hidden');
            // $ship_name_display.removeClass('hidden');
            $shipping_list_container.removeClass("hidden");
          },
          error: function (erro) {
            console.log(
              "Erro ao consultar os fretes disponíveis, tente novamente"
            );
          },
        });
      }
    );
  }

  function select_ship(selected) {
    var name = selected.data("name"),
      price = selected.data("price"),
      formated_price = selected.data("formatted-price"),
      delivery = selected.data("delivery");

    var $display_shipping = $(".shipping-display__wrapper"),
      $ship_name_display = $(".shipping-rate-name"),
      $ship_price_display = $(".shipping-display.value"),
      $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
      $btn_calc = $(".calculate-shipping"),
      $btn_change = $(".recalculate-shipping");

    $ship_name_display.html(name);
    $ship_price_display.html(formated_price);

    $display_shipping.removeClass("hidden");
    $ship_name_display.removeClass("hidden");
    $shipping_list_container.addClass("hidden");
    $btn_calc.addClass("hidden");
    $btn_change.removeClass("hidden");
  }

  function show_rate_list() {
    var $shipping_list_container = $(".cart-drawer__footer__shipping_options");
    $shipping_list_container.removeClass("hidden");
  }

  function reset_ship() {
    var $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
      $display_shipping = $(".shipping-display__wrapper"),
      $btn_calc = $(".calculate-shipping"),
      $btn_change = $(".recalculate-shipping"),
      $input_cep = $(".zipcode-input");

    $shipping_list_container.addClass("hidden");
    $display_shipping.addClass("hidden");
    $btn_change.addClass("hidden");
    $btn_calc.removeClass("hidden");
    $input_cep.val("").focus();
  }

  $(document).on("click", ".calculate-shipping", function (e) {
    shipping_ajax();
  });

  $(document).on("click", ".recalculate-shipping", function (e) {
    reset_ship();
  });

  $(document).on("click", "[data-shipping-change]", function (e) {
    select_ship($(this).find("input"));
  });

  $(document).on("click", ".show-rates-list", function (e) {
    show_rate_list();
  });

  var videoButton = document.getElementById("video-button");
  var videoOverlay = document.getElementById("video-overlay");
  var videoContainer = document.getElementById("video-container");
  var videoPlayer = document.getElementById("video-player");
  var closeButton = document.getElementById("close-button");

  if (videoButton) {
    videoButton.addEventListener("click", function () {
      videoPlayer.play();
      videoOverlay.style.display = "block";
      //Verify if the container is exceeding the max-height
      if (videoContainer.offsetHeight > videoContainer.style.maxHeight) {
        videoContainer.classList.add("video-overflow");
      }
    });

    closeButton.addEventListener("click", function () {
      videoOverlay.style.display = "none";
      videoContainer.classList.remove("video-overflow");
      videoPlayer.pause();
    });

    videoOverlay.addEventListener("click", function (event) {
      if (event.target == this) {
        videoOverlay.style.display = "none";
        videoContainer.classList.remove("video-overflow");
        videoPlayer.pause();
      }
    });
  }

  $(".review-slider-container").slick({
    dots: true,
    verticalSwiping: false,
    slidesToShow: 3.15,
    slidesToScroll: 3,
    cssEase: "ease",
    adaptiveHeight: true,
    autoplay: false,
    arrows: true,
    nextArrow: window.arrows.icon_next,
    prevArrow: window.arrows.icon_prev,
    initialSlide: 0,
    speed: 500,
    infinite: false,
    responsive: [{
      breakpoint: 1280,
      settings: {
        slidesToShow: 2.1,
        slidesToScroll: 2,
        initialSlide: 0
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1.05,
        slidesToScroll: 1,
        initialSlide: 0
      }
    }
  
    ]
  })

  const claimsWrappers = $(".claims-wrapper")
  claimsWrappers.each(function() {
    $(this).slick({
      dots: true,
      arrows: false,
      slidesToShow: 6,
      slidesToScroll: 6,
      initialSlide: 0,
      infinite: false,
      responsive: [
        {
          breakpoint: 1600,
          settings: {slidesToShow: 6, slidesToScroll: 6, initialSlide: 0}
        },
        {
          breakpoint: 1240,
          settings: {slidesToShow: 4.5, slidesToScroll: 1, initialSlide: 0}
        },
        {
          breakpoint: 920,
          settings: {slidesToShow: 2.5, slidesToScroll: 2, initialSlide: 0}
        },
        {
          breakpoint: 500,
          settings: {slidesToShow: 1.75, slidesToScroll: 1, initialSlide: 0}
        },
      ]
    })
  })

  // UPSELL Carrinho
  window.upsellSliderInit = function () {
    // $(".recommend-slider .swiper-wrapper").slick({
    //   slidesToShow: 3,
    //   slidesToScroll: 3,
    //   variableWidth: true,
    //   dots: true,
    //   infinite: false,
    //   arrows: true,
    //   prevArrow: ".swiper-button-prev",
    //   nextArrow: ".swiper-button-next",
    //   responsive: [
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         variableWidth: true,
    //         centerMode: false,
    //       },
    //     },
    //   ],
    // });]

    Fancybox.bind("[data-fancybox*='upsell']", {
      dragToClose: false,
      parentEl: $(document.body).hasClass('template-cart') ? document.querySelector(`body`) : document.querySelector('.halo-cart-sidebar'),
      closeButton: false
    });

    $(".recommend-container").addClass("loaded");
  };

  function beforeSend(element) {
    $("#dropdown-cart").addClass("updating-cart");
    $(element).find(".recommend-btn-add").addClass("is-loading");
  }

  function afterSend(element) {
    $("#dropdown-cart").removeClass("updating-cart");
    $(element).find(".recommend-btn-add").removeClass("is-loading");
  }

  $(document).on("submit", ".upsell-form", function (e) {
    e.preventDefault();

    const formData = new FormData(this);
    const serializedData = {};
    formData.forEach((value, key) => {
      serializedData[key] = value;
    });
    const jsonData = JSON.stringify(serializedData);

    // URL da API da Shopify para adicionar um item ao carrinho
    const addToCartUrl = window.Shopify.routes.root + "cart/add.js";

    // Opções da requisição
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: jsonData,
    };

    beforeSend(e.target); // Ação "before send" antes da requisição

    // Faz a requisição usando fetch com ação "before send" e "after send"
    fetch(addToCartUrl, requestOptions)
      .then((response) => {
        afterSend(); // Ação "after send" após a conclusão da requisição

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // A requisição foi bem-sucedida, você pode atualizar o carrinho ou fazer outras ações necessárias aqui

         Fancybox.close('upsell')
        Shopify.getCart(window.updateCart);
        $("body").addClass("cart-sidebar-show");
      })
      .catch((error) => {
        // Houve um erro na requisição, você pode tratar o erro aqui
        console.error("Error:", error);
      });
  });

  $(document).on("change", ".variants-product-selects select", function () {
    var $currentSelect = $(this);
    var $nextSelect = $currentSelect
      .closest(".variants-product-selects")
      .find("select")
      .eq($currentSelect.index() + 1);

    if (
      $nextSelect.length &&
      $nextSelect.is(":hidden") &&
      $nextSelect.find("option").length > 1
    ) {
      $nextSelect.show();
    } else {
      var selectedOptions = $currentSelect
        .closest(".variants-product-selects")
        .find("select")
        .map(function () {
          return $(this).val();
        })
        .get();
      var productData = JSON.parse(
        $currentSelect
          .closest(".variants-product-selects")
          .find("[data-json-product]")
          .text()
      );

      var matchingVariant = productData.find(function (variant) {
        return selectedOptions.every(function (option, index) {
          return variant.options[index] === option;
        });
      });

      if (matchingVariant && matchingVariant.available) {
        $currentSelect
          .closest(".variants-product-selects")
          .find(".variantIdAddCart")
          .val(matchingVariant.id);
        $currentSelect
          .closest(".variants-product-selects")
          .find(".recommend-btn-add")
          .prop("disabled", false);
        $currentSelect
          .closest(".variants-product-selects")
          .find(".recommend-btn-add")
          .val("ADICIONAR");
      } else {
        $currentSelect
          .closest(".variants-product-selects")
          .find(".recommend-btn-add")
          .prop("disabled", true);
        $currentSelect
          .closest(".variants-product-selects")
          .find(".recommend-btn-add")
          .val("ESGOTADO");
      }
    }

    var container = $(".halo-cart-sidebar").find(".previewCart");
    var scrollTo = $(".halo-cart-sidebar").find(".recommend-container");

    // A posição de rolagem final é a posição do topo do .recommend-container mais sua altura
    var scrollPosition =
      scrollTo.offset().top +
      scrollTo.outerHeight() +
      container.scrollTop() -
      container.position().top;

    // Realiza a rolagem
    container.animate(
      {
        scrollTop: scrollPosition,
      },
      1000
    ); // 1000 milissegundos para a animação de rolagem
  });

  /* Rotate images */
  const imgs = document.querySelectorAll('.image-rotate img');

  imgs.forEach(img => { img.style.rotate = '0deg'; });

  let lastScrollY = window.scrollY;

  const io = new IntersectionObserver((entries) => {
    const scrollingDown = window.scrollY > lastScrollY;
    lastScrollY = window.scrollY;

    entries.forEach(entry => {
      const img = entry.target;
      const angle = img.dataset.rotate || '3deg';

      if (entry.isIntersecting) {
        console.log("entrou no view")
        // entrou na seção → aplica o ângulo com transição
        requestAnimationFrame(() => { img.style.rotate = angle; });
      } else {
        console.log("Saiu do view")
        // saiu da viewport; se saiu pelo topo, zera
        // (quando top < 0 significa que o elemento está acima)
        const leftByTop = entry.boundingClientRect.top < 0;
        if (leftByTop && scrollingDown) {
          img.style.rotate = '0deg';
        }
      }
    });
  }, {
    root: null,
    threshold: 0.35,          // só “conta” quando ~35% está visível
    rootMargin: '0px 0px 0px 0px'
  });

  imgs.forEach(img => io.observe(img));
});

